import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Toast({ text, showCheck = true }) {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        @keyframes ql-toast-in {
          from { opacity: 0; transform: translateX(-50%) translateY(8px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      ` }), _jsxs("div", { style: {
                    position: 'fixed',
                    bottom: 22,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    background: '#0F172A',
                    color: '#FFFFFF',
                    fontSize: 12.5,
                    padding: '9px 14px',
                    borderRadius: 9,
                    zIndex: 60,
                    boxShadow: '0 8px 24px rgba(15,23,42,.28)',
                    animation: 'ql-toast-in 0.25s ease-out',
                }, children: [showCheck ? (_jsx("span", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 15,
                            height: 15,
                            borderRadius: '50%',
                            background: '#22C55E',
                            flex: 'none',
                        }, children: _jsx("svg", { width: "9", height: "9", viewBox: "0 0 24 24", fill: "none", stroke: "#FFFFFF", strokeWidth: "3.4", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M20 6L9 17l-5-5" }) }) })) : null, _jsx("span", { children: text })] })] }));
}
